/**
 * Using these config values allows multiple design configurations depending
 * on which index is chosen.
 */
import Login from '@/components/Login';
import Search from '@/components/Search';
import Interview from '@/components/interview/Interview';
import NameInsured from '@/components/interview/Auto/RC1/NameInsured';
import Vehicles from '@/components/interview/Auto/RC1/Vehicles';
import Drivers from '@/components/interview/Auto/RC1/Drivers';
import PriorInsurance from '@/components/interview/Auto/RC1/PriorInsurance';
import NewCoverages from '@/components/interview/Auto/RC1/NewCoverages';
import CarrierMatches from '@/components/interview/Auto/RC1/Listing';
import ResetPassword from '@/components/user/ResetPassword';
// import Checkout from '@/components/interview/Checkout/Checkout';
import ContactDetails from '@/components/interview/Auto/RC2/ContactDetails';
import PolicyDetails from '@/components/interview/Auto/RC2/PolicyDetails';
import DriverVehicleDetails from '@/components/interview/Auto/RC2/DriverVehicleDetails';
import Checkout from '@/components/interview/Auto/RC2/AutoBundleCheckout';
import Confirmation from '@/components/interview/Auto/RC2/AutoBundleConfirmation';
import Dashboard from '@/components/admin/dashboard/Dashboard';
import NonEndToEnd from '@/components/interview/shared/NonEndToEnd';


let variations = {};
// Referred to as "vacation design"
variations['1.1'] = [
  {
    path: 'name-insured',
    component: NameInsured,
    meta: {
      rateCall: 1,
    },
  },
  {
    path: 'drivers',
    component: Drivers,
    meta: {
      rateCall: 1,
    },
  },
  {
    path: 'vehicles',
    component: Vehicles,
    meta: {
      rateCall: 1,
    },
  },
  {
    path: 'prior-insurance',
    component: PriorInsurance,
    meta: {
      rateCall: 1,
    },
  },
  {
    path: 'coverage',
    component: NewCoverages,
    meta: {
      rateCall: 1,
    },
  },
  {
    path: 'carrier-matches',
    component: CarrierMatches,
    meta: {
      rateCall: 1,
    },
  },
  {
    path: 'non-end-to-end',
    name: 'auto/non-end-to-end',
    component: NonEndToEnd,
    meta: { parentPath: 'rc2', page: 'hocoverage' },
  },
  {
    path: '**/rc2-contact-details',
    component: ContactDetails,
    meta: {
      rateCall: 2,
    },
  },
  {
    path: '**/rc2-policy-details',
    component: PolicyDetails,
    meta: {
      rateCall: 2,
    },
  },
  {
    path: '**/rc2-driver-vehicle-details',
    component: DriverVehicleDetails,
    meta: {
      rateCall: 2,
    },
  },
  {
    path: '**/checkout',
    component: Checkout,
    meta: { rateCall: 3, parentPath: 'rc2', page: 'hocheckout' },//TODO: check if we can add it conditionally only for bundle
    // meta: {
    //   rateCall: 3,
    // },
  },
  {
    path: '**/confirmation',
    component: Confirmation,
    meta: { rateCall: 3, parentPath: 'rc2', page: 'hoconfirmation' },//TODO: check if we can add it conditionally only for bundle
    // meta: {
    //   rateCall: 3,
    // },
  },
  {
    path: '/admin/dashboard',
    component: Dashboard,
  },
];

export default variations;


//////////////////
// WEBPACK FOOTER
// ./config/variations.js
// module id = null
// module chunks = 